import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CartItemsList } from "./CartItemsList";

const fmt = (n) => new Intl.NumberFormat("fr-FR").format(n);

export const CartConfirmDialog = ({ open, onOpenChange, items, itemsTotal, deliveryFee, deliveryAddress, paymentLabel, onConfirm, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#1A1A1A] border-white/10 text-white max-w-lg rounded-3xl" data-testid="cart-confirm-dialog">
      <DialogHeader>
        <DialogTitle className="text-white font-black uppercase tracking-widest text-base">Vérifiez votre commande</DialogTitle>
        <DialogDescription className="text-white/60 text-sm">
          Contrôlez vos produits avant de confirmer.
        </DialogDescription>
      </DialogHeader>
      <div className="max-h-[40vh] overflow-y-auto pr-1">
        <CartItemsList items={items} readOnly />
      </div>
      <div className="space-y-2 text-sm border-t border-white/10 pt-4">
        <div className="flex justify-between"><span className="text-white/60">Articles</span><span className="font-black" data-testid="confirm-items-total">{fmt(itemsTotal)} FCFA</span></div>
        <div className="flex justify-between"><span className="text-white/60">Livraison</span><span className="font-black" data-testid="confirm-delivery-fee">{fmt(deliveryFee)} FCFA</span></div>
        <div className="flex justify-between"><span className="text-white/60">Livrer à</span><span className="font-bold text-right max-w-[60%] truncate">{deliveryAddress}</span></div>
        <div className="flex justify-between"><span className="text-white/60">Paiement</span><span className="font-bold">{paymentLabel}</span></div>
        <div className="flex justify-between text-lg pt-3 border-t border-white/10">
          <span className="text-[#D4AF37] font-black uppercase tracking-widest text-sm">Total</span>
          <span className="text-[#D4AF37] font-black" data-testid="confirm-grand-total">{fmt(itemsTotal + deliveryFee)} FCFA</span>
        </div>
      </div>
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 rounded-full bg-transparent border-white/20 text-white hover:bg-white/10" data-testid="confirm-cancel-btn">
          Modifier
        </Button>
        <Button onClick={onConfirm} disabled={loading} className="flex-1 rounded-full bg-[#D4AF37] hover:bg-[#B8962E] text-[#0F172A] font-black" data-testid="confirm-order-btn">
          {loading ? "Envoi..." : "Confirmer ma commande"}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
